import { useThemeContext } from "../../context/ThemeContext";

import styles from "./Card.module.css";

import { CardLabelProps } from "./types";

export function CardLabel({ cardLabelType, cardLabelText }: CardLabelProps) {
  const theme = useThemeContext();

  return cardLabelType === "dot" ? (
    <div
      className={`${styles.cardLabel} ${styles.dotLabel}`}
      style={{ color: theme.moss }}
    >
      <span className={styles.dot} style={{ background: theme.moss }} />
      {cardLabelText}
    </div>
  ) : (
    <div className={styles.cardLabel} style={{ color: theme.muted }}>
      {cardLabelText && `✦ ${cardLabelText}`}
    </div>
  );
}
